// src/components/skeletons/ProductSkeleton.jsx

import React from "react";

const ProductSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8 animate-pulse">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left - Image Skeleton */}
        <div className="w-full lg:w-1/2">
          <div className="w-full h-[500px] bg-gray-200 rounded-md" />
          <div className="flex gap-3 mt-4">
            {[...Array(4)].map((_, idx) => (
              <div key={idx} className="w-20 h-20 bg-gray-200 rounded-md" />
            ))}
          </div>
        </div>

        {/* Right - Info Skeleton */}
        <div className="w-full lg:w-1/2 space-y-4">
          <div className="h-6 bg-gray-300 rounded w-3/4" />
          <div className="h-4 bg-gray-300 rounded w-1/2" />
          <div className="h-6 bg-gray-300 rounded w-1/3 mt-2" />

          <div className="h-20 bg-gray-200 rounded mt-4" />

          {/* Color */}
          <div className="mt-4">
            <div className="h-4 bg-gray-300 rounded w-24 mb-2" />
            <div className="flex gap-2">
              {[...Array(4)].map((_, idx) => (
                <div key={idx} className="w-8 h-8 rounded-full bg-gray-300" />
              ))}
            </div>
          </div>

          {/* Size */}
          <div className="mt-4">
            <div className="h-4 bg-gray-300 rounded w-20 mb-2" />
            <div className="flex gap-2">
              {[...Array(3)].map((_, idx) => (
                <div key={idx} className="px-3 py-2 bg-gray-300 rounded" />
              ))}
            </div>
          </div>

          {/* Quantity + Add to Cart */}
          <div className="flex items-center gap-4 mt-6">
            <div className="h-8 w-20 bg-gray-300 rounded" />
            <div className="h-10 w-32 bg-gray-400 rounded" />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-12">
        <div className="flex gap-6 border-b pb-4">
          {["Description", "Additional Info", "Reviews"].map((tab, idx) => (
            <div key={idx} className="w-24 h-5 bg-gray-300 rounded" />
          ))}
        </div>
        <div className="mt-4 space-y-3">
          {[...Array(4)].map((_, idx) => (
            <div key={idx} className="h-4 bg-gray-200 rounded w-full" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
